import { Skeleton, type SkeletonProps } from "./Skeleton";

import * as styles from "./Skeleton.module.scss";

const SkeletonParagraph = ({ mode = "dark" }: SkeletonProps) => (
  <div className={styles.skeletonParagraphWrapper}>
    <Skeleton className={styles.skeletonParagraph} mode={mode} />
    <Skeleton className={styles.skeletonParagraph} mode={mode} />
    <Skeleton className={styles.skeletonParagraph} mode={mode} />
    <Skeleton className={styles.skeletonParagraph} mode={mode} />
  </div>
);

export default SkeletonParagraph;
